import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { getAuth } from 'firebase/auth';
import { FmErrorHandlerService } from '../../core/fm-error-handler.service';

export const authGuard: CanActivateFn = async (route, state) => {
  const auth = getAuth();
  const router = inject(Router);
  const errorService = inject(FmErrorHandlerService);

  await auth.authStateReady();
  const currentUser = auth.currentUser;

  if (!currentUser) {
    return new RedirectCommand(router.parseUrl('/'));
  }
  return true;
};
